module.exports = __webpack_public_path__ + "img/logo1.fba52c7a.png";